export function LoadingScreen() {
  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 14,
        color: 'var(--ink-3)',
      }}
    >
      <span
        style={{
          width: 18,
          height: 18,
          borderRadius: 999,
          border: '2px solid var(--paper-3)',
          borderTopColor: 'var(--ink)',
          animation: 'spin 700ms linear infinite',
        }}
      />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <div className="eyebrow">загружаем</div>
    </div>
  );
}
